import ReportCard from "../../../../../../components/reports/report-card.jsx";
import {useEffect} from "react";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function CardsContent({ data }) {
    const cloneCard = data?.cloneCards?.[0] ?? {};
    const averageTime = data?.averageTime ?? "0s";

    useEffect(() => {
        const tableRows = [
            ["Total de notificações", cloneCard?.qty ?? 0],
            ["Notificações verificadas", cloneCard?.verified ?? 0],
            ["Ocorrências geradas", cloneCard?.occ ?? 0],
            ["Tempo médio para verificação", averageTime],
        ];

        ReportUtils.createExportableTable(
            ["Descrição", "Quantidade"],
            tableRows,
            "Cards",
        );
    }, [cloneCard]);

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-2">
                    <ReportCard
                        title="Total de notificações"
                        value={cloneCard?.qty ?? 0}
                    />
                    <ReportCard
                        title="Notificações verificadas"
                        value={cloneCard?.verified ?? 0}
                    />
                </div>
                <div className="grid grid-cols-2">
                    <ReportCard
                        title="Ocorrências geradas"
                        value={cloneCard?.occ ?? 0}
                    />
                    <ReportCard
                        title="Tempo médio para verificação"
                        value={averageTime}
                    />
                </div>
            </div>
            <div className="chart-divisor" />
        </>
    )
}